export default __webpack_public_path__ + "static/media/poly-plus-badge.b57cd0af.svg";